import i18n from '../i18n';
import { EN_SLUGS } from '../config/enSlugs';

// Tarih ve sayı biçimlendirme için aktif dile uygun yerel ayar
// ("24 Mayıs 2024" / "May 24, 2024", "1.376" / "1,376") — sitede Amerikan İngilizcesi kullanılıyor
export const dateLocale = () => ((i18n.language || '').startsWith('en') ? 'en-US' : 'tr-TR');

// Veritabanındaki tarihleri okur: "16.04.2026", "16.04.2026 14:00", "2026-04-16", ISO.
// new Date("16.04.2026") tarayıcıda "Invalid Date" verdiği için gerekli.
export const parseFlexibleDate = value => {
  if (!value) return new Date(NaN);
  if (value instanceof Date) return value;
  const s = String(value).trim();
  const m = s.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2}))?/);
  if (m) return new Date(+m[3], +m[2] - 1, +m[1], +(m[4] || 0), +(m[5] || 0));
  return new Date(s.includes(' ') && !s.includes('T') && /^\d{4}-/.test(s) ? s.replace(' ', 'T') : s);
};

// ── Türkçe ⇄ İngilizce sayfa adresleri (eşleşmeler: config/enSlugs.js) ──
const byLength = (a, b) => b[0].length - a[0].length; // en uzun önek önce
const TR_TO_EN = Object.entries(EN_SLUGS).sort(byLength);
const EN_TO_TR = [];
for (const [tr, en] of Object.entries(EN_SLUGS)) if (!EN_TO_TR.some(([e]) => e === en)) EN_TO_TR.push([en, tr]);
EN_TO_TR.sort(byLength);

const splitPath = full => { const i = full.search(/[?#]/); return i < 0 ? [full, ''] : [full.slice(0, i), full.slice(i)]; };
const mapPrefix = (path, table) => {
  for (const [from, to] of table) {
    if (path === from || path.startsWith(from + '/')) return to + path.slice(from.length);
  }
  return null;
};

// Türkçe adres (ya da eski /en/<türkçe> adres) → İngilizce adres: /ogrenci-topluluklari → /en/student-clubs
export const toEnPath = full => {
  let [path, rest] = splitPath(full || '/');
  if (path === '/en' || path.startsWith('/en/')) path = path.slice(3) || '/';
  if (path === '/') return '/en' + rest;
  return '/en' + (mapPrefix(path, TR_TO_EN) || path) + rest;
};

// İngilizce adres → Türkçe adres: /en/student-clubs → /ogrenci-topluluklari
export const toTrPath = full => {
  let [path, rest] = splitPath(full || '/');
  if (!(path === '/en' || path.startsWith('/en/'))) return path + rest;
  path = path.slice(3) || '/';
  if (path === '/') return '/' + rest;
  return (mapPrefix(path, EN_TO_TR) || path) + rest;
};

// Aktif dile göre site içi bağlantı: localizePath('/staj') → '/staj' ya da '/en/internship'
export const localizePath = trPath => ((i18n.language || '').startsWith('en') ? toEnPath(trPath) : trPath);
